<div class="toggle-mode w-pill mx-auto bg-primary-light rounded-5 mt-4 mb-4">
    <ul class="nav nav-pills   justify-content-center">
        <li class="nav-item">
            <a class="nav-link  active rounded-5" aria-current="page" [class.active]="isActive('/')"
            (click)="updateRoute('/')">Play</a>
        </li>
        <li class="nav-item">
            <a class="nav-link rounded-5" [class.active]="isActive('/work')" (click)="updateRoute('/work')">Work</a>
        </li>

    </ul>
</div>